import React, { useState, useEffect } from "react";
import ssoManagementService from "../../../services/SSOManagementService";
import provisionService from "../../../services/ProvisionService";
import {
  ProviderSiteDTO,
  SiteDTO,
  Environments,
} from "@beable/roster-backend-client-v1";
import { emptySSOProviderSite } from "../../../test/fixtures";
import ProviderSiteForm from "../Sites/ProviderSiteForm";
import FormModal, {
  ModalMessageSettings,
  getResultMessage,
} from "../../Common/FormModal";

interface EditProviderSiteModalProps {
  open: boolean;
  handleClose: any;
  siteItem: ProviderSiteDTO;
}

export default function EditProviderSiteModal(
  props: EditProviderSiteModalProps
) {
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();
  const [isLoading, setIsLoading] = useState(false);
  const [ssoProviderSite, setSSOProviderSite] = useState<ProviderSiteDTO>(
    props.siteItem
  );
  const [selectedSite, setSelectedSite] = useState<SiteDTO | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchSiteAndSetItem = async () => {
      setIsLoading(true);
      const site = await provisionService.getSitesById(props.siteItem.siteId);
      if (site) {
        setSelectedSite(site);
        setSSOProviderSite((ssoProvider) => {
          return { ...ssoProvider, siteId: site.id, siteName: site.subdomain };
        });
      }

      setSSOProviderSite({
        id: props.siteItem.id ?? emptySSOProviderSite.id,
        siteId: props.siteItem.siteId ?? emptySSOProviderSite.siteId,
        providerId: props.siteItem.provider?.name || "unkown",
        identifier:
          props.siteItem.identifier ?? emptySSOProviderSite.identifier,
        active:
          props.siteItem.active !== undefined
            ? props.siteItem.active
            : emptySSOProviderSite.active,
        siteName: props.siteItem?.siteName ?? emptySSOProviderSite.siteName,
        providerValidation: props.siteItem
          ? props.siteItem.providerValidation
          : emptySSOProviderSite.providerValidation,
        providerValidationString: props.siteItem
          ? props.siteItem.providerValidationString
          : emptySSOProviderSite.providerValidationString,
      });
      setIsLoading(false);
    };
    fetchSiteAndSetItem();
  }, [props]);

  const submitForm = async (
    siteDto: ProviderSiteDTO,
    _allEnvs: boolean,
    env: string
  ) => {
    setIsLoading(true);
    const { success, error }  = await ssoManagementService.updateProviderSite(siteDto, env);
    const message = getResultMessage(success ? true : undefined, success, error);
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title={`Edit ${props.siteItem.provider?.name}`}
      description={`Edits the ${props.siteItem.provider?.name} site for ${props.siteItem.provider?.environment}.`}
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      <ProviderSiteForm
        onSubmit={submitForm}
        handleClose={handleClose}
        selectedItem={ssoProviderSite}
        site={selectedSite}
        env={props.siteItem.provider?.environment as Environments}
      />
    </FormModal>
  );
}
